import React, { useMemo } from 'react';

import { ChevronLeftIcon, ChevronRightIcon } from '../../../../../assets';
import { Button } from '../../../../Button';
import { useTableContext } from '../../../contexts';
import { getPagination } from '../../../utils';

import styles from './PageNavigation.module.scss';

export interface IPageNavigationProps {}
//
export const PageNavigation: React.FC<IPageNavigationProps> = () => {
    const {
        getPageCount,
        getRowModel,
        getCanPreviousPage,
        getCanNextPage,
        previousPage,
        nextPage,
        setPageIndex,
        state: { pagination },
    } = useTableContext();

    const pageCount = useMemo(() => getPageCount() || 1, [getRowModel().rows]);
    const currentPage = useMemo(() => pagination.pageIndex + 1, [pagination]);

    const paginationStructure = useMemo(() => {
        return getPagination(currentPage, pageCount, 2);
    }, [pageCount, currentPage]);

    return (
        <div className={styles.navigationWrapper}>
            <Button
                variant="fab"
                size="small"
                color="transparent"
                disabled={!getCanPreviousPage()}
                onClick={() => previousPage()}
            >
                <ChevronLeftIcon />
            </Button>
            {paginationStructure.map((page, index) => (
                <Button
                    key={index}
                    variant="fab"
                    size="small"
                    color={page === currentPage ? 'primary' : 'transparent'}
                    onClick={() => typeof page === 'number' && setPageIndex(page - 1)}
                >
                    {page}
                </Button>
            ))}
            <Button
                variant="fab"
                size="small"
                color="transparent"
                disabled={!getCanNextPage()}
                onClick={() => nextPage()}
            >
                <ChevronRightIcon />
            </Button>
        </div>
    );
};
